"use client";
import localStorageCall from '@/services/Methods/localstorage.hook';
import { MiniLoader, storeAssigned } from '@/services/Methods/normalMethods';
import { useRouter } from 'next/navigation';
import React, { useEffect, useState } from 'react';
import NewCustomHeader from './NewCustomHeader';
import { KeyboardArrowDown, Person } from '@mui/icons-material';
import * as Sentry from "@sentry/react";
import { MyAccoutnAPI } from '@/services/Redux/Reducer/LoginSlice';
import { useDispatch } from 'react-redux';
import ReactCountryFlag from 'react-country-flag';
import CountryFlagDropdown from './CountryFlagDropdown';
import _ from 'lodash';
import { IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Image from 'next/image';
import Link from 'next/link';
import { whitelogo, BhipLogo, searchIcon, cartIcon, Logo } from '@/assets/images';
import { IoMdMenu } from "react-icons/io";
import { IoClose } from "react-icons/io5";


const Header = ({ showCountries, setShowCountries, selectedStore, setSelectedStore, countyObjects, userData, pathname, ...props }) => {
  const isUserLogin = localStorageCall().getItem('Token');
  const router = useRouter();
  const { joinPopup, setJoinPopup } = props;
  const [showCurrencies, setShowCurrencies] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleLogout = () => {
    localStorageCall().removeItem('Token');
    localStorageCall().removeItem('customerTypeDescr');
    localStorageCall().removeItem("refferal_link");
    localStorageCall().removeItem('partyPlanId');
    localStorageCall().removeItem('Dates');
    localStorageCall().removeItem('activeStep');
    localStorageCall().removeItem('showPopupDismissed');
    localStorageCall().removeItem('chngecountryfromdrop');
    localStorageCall().removeItem('RenewalProduct');
    localStorageCall().removeItem('TreeMoveData');
    localStorageCall().removeItem('normalProducts');
    sessionStorage.removeItem('user_session_id');

    Sentry.setUser(null);
    window.location.assign(`/${storeAssigned()}`);
  }

  const handleSignin = () => {
    // router.push(`/${storeAssigned()}/signin`)
    window.location.assign(`${process.env.NEXT_PUBLIC_ABO_URL}`);
  }

  const handleHome = () => {
    router.push(`/${storeAssigned()}`)
  }

  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
    document.body.classList.add("overflow-hidden");
  };

  const handleDrawerClose = () => {
    setOpen(false);
    document.body.classList.remove("overflow-hidden");
  };

  const dispatch = useDispatch();

  function handleBackOffice() {
    if (isUserLogin) {
      dispatch(MyAccoutnAPI())
    }
    else {
      navigate(`/${storeAssigned()}/${ROUTING_TEXT?.login_routingName}`)
    }
  };

  const GotoHome = () => {
    router.push(`/${storeAssigned()}/`);
  }
  const handleLogin = () => {
    router.push(`/${storeAssigned()}/signin`);
  }

  const handleJoin = () => {
    router.push(`/${storeAssigned()}/distributor`);
  }
  const textColor = pathname === "/us" && "text-black";
  const logoClass = pathname === "/us" ? "md:w-[150px] w-[80px]" : "filter md:w-[150px] w-[80px] ";
  const bgColor = pathname === "/us" ? "bg-[#0088c7]" : "bg-white";

  useEffect(() => {
    const handleClickOutside = (event) => {
      const weglotSwitchers = document.querySelectorAll('.weglot-container');

      weglotSwitchers.forEach((switcher) => {
        const openDropdown = switcher.querySelector('aside.open');
        const toggleButton = switcher.querySelector('.wgcurrent');

        if (
          openDropdown &&
          !switcher.contains(event.target)
        ) {
          (toggleButton)?.click();
        }
      });
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  return (
    <>
      <NewCustomHeader {...{ open, setOpen, handleDrawerOpen, handleDrawerClose, handleLogout, handleSignin, joinPopup, setJoinPopup }} />
      <div className='main-header-box'>
        <div
          className={`langi_div z-[12] relative w-full group  !bg-white 
       ${isScrolled ? `
       !bg-[#fff] hidden` : "langi_div relative w-full group  block !bg-white"}`}
        >
          <div className='relative z-10 container min-h-[6px] mx-auto  px-[15px] w-full md:py-[9px] py-[5px] flex md:justify-start justify-center items-center flex-wrap'>
            <button
              className="topbar-link dropdown-toggle flex items-center after:content-[''] after:border-top-[4px] after:block after:border-r-[4px] after:border-transparent after:ml-[4px]"
              data-toggle="dropdown" aria-expanded="false" onClick={() => {
                console.log("inside-the-button");
                setShowCountries(!showCountries);
                setShowCurrencies(false);
              }} >
              <ReactCountryFlag svg countryCode={selectedStore?.defaultCode || 'US'} className="!block !w-[20px] !h-[20px]" />
              <KeyboardArrowDown className='fill-[#212529]' />
            </button>
            <div id="weglot_here"></div>
            <CountryFlagDropdown {...{ selectedStore, setSelectedStore, countyObjects, showCountries, setShowCountries, pathname }} />
            {showCurrencies && (
              <div className="p-[10px] langu_box absolute top-full bg-white border border-gray-300 shadow-md max-w-[180px] w-full border-[rgba(0_0_0_0.15)] rounded-[5px] mt-[-10px]">
                {[...new Set(countyObjects.map((country) => country.currency))].map((currency, index) => (
                  <div
                    key={index}
                    className="p-2 px-[16px] hover:bg-gray-200 cursor-pointer"
                    onClick={() => {
                      console.log(`Currency selected: ${currency}`);
                      setShowCurrencies(false);
                    }}
                  >
                    {/* <span>{currency}</span> */}
                  </div>
                ))}

              </div>
            )}

          </div>

        </div>

        <div
          className={`bg-[#0388c7] lg:py-[22px] py-[12px] flex justify-between items-center join-now-main ${isUserLogin ? 'logged_in_header' : ''
            } ${isScrolled ? ' hidden' : 'langi_div relative w-full group'}`}
        >

          <div className='container px-[15px]  mx-auto lg_container flex justify-center sm:justify-between items-center  md:flex-row flex-col lg:gap-y-[0] md:gap-y-[10px] gap-y-[5px]'>
            <div
              className={`langi_div z-[12] relative w-full group md:block  hidden pl-2 opacity-0 max-w-max
       ${isScrolled ? ` opacity-100 !block  transition-all duration-200  
       !bg-[#fff]   ` : "langi_div relative w-full group  "}`}
            >

              <div className='relative z-10 w-auto  flex sm:justify-start justify-center items-center flex-wrap'>
                {/* <button
                  className="disable topbar-link dropdown-toggle flex items-center after:content-[''] after:border-top-[4px] after:block after:border-r-[4px] after:border-transparent after:ml-[4px]"
                  data-toggle="dropdown" aria-expanded="false" onClick={() => {
                    setShowCountries(!showCountries);
                    setShowCurrencies(false);
                  }} onBlur={() => {
                    setShowCountries(false);
                  }}>
                  <ReactCountryFlag svg countryCode={selectedStore?.defaultCode || 'US'} className="!block !w-[20px] !h-[20px]" />
                  <KeyboardArrowDown className='fill-[#212529]' />
                </button>
                <div id="weglot_here"></div>
                <CountryFlagDropdown {...{ selectedStore, setSelectedStore, countyObjects, showCountries, setShowCountries, pathname }} />
                {showCurrencies && (
                  <div className="p-[10px] langu_box absolute top-full bg-white border border-gray-300 shadow-md max-w-[180px] w-full border-[rgba(0_0_0_0.15)] rounded-[5px] mt-[-10px]">
                    {[...new Set(countyObjects.map((country) => country.currency))].map((currency, index) => (
                      <div
                        key={index}
                        className="p-2 px-[16px] hover:bg-gray-200 cursor-pointer"
                        onClick={() => {
                          console.log(`Currency selected: ${currency}`);
                          setShowCurrencies(false);
                        }}
                      >
                        <span>{currency}</span>
                      </div>
                    ))}

                  </div>
                )} */}

              </div>

            </div>
            <div className='flex items-center'>

              {/* <p className='text-[21px] font-bold text-white'>presented by: Jane Doe</p> */}
              <div className='extraHeader w-full '>
                <ul className="menu-list flex lg:gap-[50px] md:gap-[11px]  gap-[9px] sm:justify-start justify-center flex-wrap items-center ">
                  {/* <li className="menu-item text-[14px] cursor-pointer">Referring Member</li> */}
                  <li className="menu-item text-white lg:text-[18px] md:text-[14px] text-sm lg:tracking-[1px] tracking-[0px] md:text-left text-center">
                    {!(isUserLogin) ? `${localStorageCall().getItem('refferal_link')?.name ? 'presented by' + ': ' + localStorageCall().getItem('refferal_link')?.name : ''}`
                      :
                      'Welcome' + ', ' + (userData?.fullName || '')

                    }
                  </li>
                  {isUserLogin ?
                    <li className="menu-item cursor-pointer text-white lg:text-[18px] md:text-[14px] text-sm lg:tracking-[1px] tracking-[0px]" onClick=''>Backoffice</li>
                    :
                    <li className="menu-item cursor-pointer text-white lg:text-[18px] md:text-[14px] text-sm lg:tracking-[1px] tracking-[0px]" onClick={handleJoin}>find an affiliate</li>
                  }
                  {
                    !isUserLogin && (<li className="menu-item cursor-pointer text-white lg:text-[18px] md:text-[14px] text-sm lg:tracking-[1px] tracking-[0px]" onClick={handleJoin}>Join Now</li>)}
                  <li className="menu-item cursor-pointer text-white lg:text-[18px] md:text-[14px] text-sm lg:tracking-[1px] tracking-[0px]" onClick={() => isUserLogin ? handleLogout() : handleLogin()}>{isUserLogin ? 'Logout' : 'Login'}</li>
                </ul>
              </div>

            </div>
          </div>
        </div>

        <header
          className={`site-header  py-[15px] left-0 w-full z-10 transition-all duration-300 
      ${isScrolled ? `${bgColor} shadow-lg  ` : "bg-transparent"} ${isMenuOpen ? 'menuOpen' : ''}`}
        >

          <div className="container mx-auto px-[15px] lg_container">
            <nav className='nav-bar flex items-center justify-between'>
              <div
                className={`logo cursor-pointer mr-auto pr-4 ${isScrolled ? 'scrolled-class' : ''}`}
                onClick={GotoHome}
              >
                {/* {pathname.inclues('products') */}
                {(pathname?.includes('products') || pathname?.includes('lifestyle') || pathname?.includes('aboutus') || pathname?.includes('aboutus') || pathname?.includes('distributor') || pathname?.includes('signin') || pathname?.includes('checkout')) ?
                  <Image src={Logo} alt="whitelogo" className={logoClass} />
                  :

                  <Image src={Logo} alt="whitelogo" className={logoClass} />
                }
              </div>

              <ul className={`flex   pr-[20px] 2xl:max-w-[1210px] xl:max-w-[700px] lg:max-w-[550px]  md:max-w-[400px] w-full justify-end 2xl:gap-[10rem] xl:gap-[8rem] lg:gap-[4rem] gap-[2rem]`}>
                <li>
                  <Link
                    href={`/${storeAssigned()}/products`}
                    className={`${textColor} lg:text-[21px] text-[18px] tracking-[1px] !no-underline`}
                  >
                    Products
                  </Link>
                </li>
                <li>
                  <Link
                    href={`/${storeAssigned()}/lifestyle`}
                    className={`${textColor} lg:text-[21px] text-[18px]  tracking-[1px] !no-underline`}
                  >
                    Lifestyle
                  </Link>
                </li>


                <li className="relative group">
                  <Link
                    href={`/${storeAssigned()}/aboutus`}
                    className={`${textColor} lg:text-[21px] text-[18px] tracking-[1px] !no-underline`}
                  >
                    About
                  </Link>

                  <ul className="children-div min-w-[252px] absolute top-[50px] left-1/2 -translate-x-1/2 
                 opacity-0 invisible group-hover:opacity-100 group-hover:visible 
                 group-hover:top-[30px] transition-all duration-300 z-50">
                    <li>
                      <a
                        href="#"
                        className="!no-underline tracking-[1px] lg:text-[21px] text-[18px] text-white bg-[#0388c7] 
                   min-h-[61px] flex justify-center items-center p-3 hover:bg-[#003a63]"
                      >
                        Our story
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="!no-underline tracking-[1px] lg:text-[21px] text-[18px] text-white bg-[#0388c7] 
                   min-h-[61px] flex justify-center items-center p-3 hover:bg-[#003a63]"
                      >
                        Vision and Values
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="!no-underline tracking-[1px] lg:text-[21px] text-[18px] text-white bg-[#0388c7] 
                   min-h-[61px] flex justify-center items-center p-3 hover:bg-[#003a63]"
                      >
                        Executive Team
                      </a>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link
                    href={`/${storeAssigned()}/aboutus`}
                    className={`${textColor} lg:text-[21px] text-[18px]  tracking-[1px] !no-underline`}
                  >
                    Contact
                  </Link>
                </li>
              </ul>

              <div className='header_icons flex items-center 2xl:gap-[30px] gap-[20px] pl-[15px]'>
                <button type="button" className='cursor-pointer'>
                  <Image src={searchIcon} alt="search-icon" className="searchClass" />
                </button>

                <Link className='#' href={`/${storeAssigned()}/cart`}>
                  <Image src={cartIcon} alt="cart-icon" className="cartClass size-8" />
                </Link>
              </div>
              <div className='manu-toggle-bar'>
                <IoMdMenu onClick={() => setIsMenuOpen(true)} />
                <IoClose onClick={() => setIsMenuOpen(false)} />
              </div>

            </nav>
          </div>
        </header>
      </div>
    </>
  );
};
export default Header;